document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".carousel-track");
  const items = document.querySelectorAll(".carousel-item");
  const nextButton = document.querySelector(".carousel-btn.next");
  const prevButton = document.querySelector(".carousel-btn.prev");

  let currentIndex = 0;

  function getItemsPerView() {
    if (window.innerWidth >= 1024) return 4;
    if (window.innerWidth >= 600) return 2;
    return 1;
  }

  function updateCarousel() {
    const itemsPerView = getItemsPerView();
    const itemWidth = items[0].offsetWidth;
    track.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex >= items.length - itemsPerView;
  }

  nextButton.addEventListener("click", function () {
    const itemsPerView = getItemsPerView();
    if (currentIndex < items.length - itemsPerView) {
      currentIndex++;
      updateCarousel();
    }
  });

  prevButton.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  window.addEventListener("resize", updateCarousel);
  updateCarousel();
});
